import { useSplitTreatments } from '@splitsoftware/splitio-react';
import { useEffect, useState } from 'react';

import { types } from './definitions';

/*
Wraps the useSplitTreatments hook provided in @splitsoftware/splitio-react. 
It's possible to only fetch/return an experiment treatment once given `fetchTreatmentOnce`
param. This is relevant to OSC since polling causes repeat re-renders and thus re-fetches.

If `accountSid` is not specified, will default to default config initialized in SplitProvider
*/
const useExperiment = ({
  experimentName,
  accountSid,
}: types.UseExperimentProps) => {
  const [isOn, setIsOn] = useState<boolean>(false);
  const [isLoadingTreatment, setIsLoadingTreatment] = useState<boolean>(true);

  const { treatments, isReady } = useSplitTreatments({
    names: [experimentName],
    ...(accountSid ? { splitKey: accountSid } : {}),
  });

  useEffect(() => {
    setIsLoadingTreatment(true);
    if (isReady) {
      setIsOn(treatments[experimentName].treatment === 'on');
      setIsLoadingTreatment(false);
    }
  }, [treatments, isReady]);

  return { isOn, isLoadingTreatment };
};

export default useExperiment;
